<template>
    <div slot="no-body" class="border-0 shadow-none border-solid border-1 md:w-2/3 lg:w-full" cardBackground="">

      <div class="text-center lg:mx-8 my-2">
        At improvee.io, we believe in simplicity and transparency when it comes to pricing. That's why we came up with a pricing plan that is easy to understand - <span class="font-semibold">it costs just like a Big Mac.</span>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      // Component data here
    }
  },
  methods: {
    // Component methods here
  },
  computed: {
    // Computed properties here
  },
  mounted() {
    // Code that runs when the component is mounted to the DOM
  }
}
</script>
